import { serviceMaker, methods, api } from "@/http/index.js";

export const getAddressData = () =>
    serviceMaker(`/address`, methods.GET, api.NGB);
export const saveCountry = (data) =>
    serviceMaker(`/address/country/new`, methods.POST, api.NGB, data);
export const saveState = (data) =>
    serviceMaker(`/address/state/new`, methods.POST, api.NGB, data);
export const saveDistrict = (data) =>
    serviceMaker(`/address/district/new`, methods.POST, api.NGB, data);
export const saveCity = (data) =>
    serviceMaker(`/address/city/new`, methods.POST, api.NGB, data);
export const editCountry = (id, data) =>
    serviceMaker(`/address/country/${id}`, methods.PUT, api.NGB, data);
export const editState = (id, data) =>
    serviceMaker(`/address/state/${id}`, methods.PUT, api.NGB, data);
export const editDistrict = (id, data) =>
    serviceMaker(`/address/district/${id}`, methods.PUT, api.NGB, data);
export const editCity = (id, data) =>
    serviceMaker(`/address/city/${id}`, methods.PUT, api.NGB, data);
export const deleteCountry = (id) =>
    serviceMaker(`/address/country/${id}`, methods.DELETE, api.NGB);
export const deleteState = (id) =>
    serviceMaker(`/address/state/${id}`, methods.DELETE, api.NGB);
export const deleteDistrict = (id) =>
    serviceMaker(`/address/district/${id}`, methods.DELETE, api.NGB);
export const deleteCity = (id) =>
    serviceMaker(`/address/city/${id}`, methods.DELETE, api.NGB);
export const servicesAvailable = () =>
    serviceMaker(`/servicemasters`, methods.GET, api.NGB);
export const getAddressServices = (id, type) =>
    serviceMaker(`/address/service/${type}/${id}`, methods.GET, api.NGB);
export const saveAddressServices = (id, data) =>
    serviceMaker(`/address/service/${id}`, methods.POST, api.NGB, data);
